import React, { Fragment, useEffect, useMemo, useState } from "react";
import Table from "../component/Table";
import axios from "axios";
import { Container, Row, Col, Image } from "react-bootstrap";
import { Button, Checkbox, Divider, Dropdown, Popup } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import { Bs0Circle, BsImage } from "react-icons/bs";
import Pesan from "../component/Pesan";
import AGtable from "../component/AGTable";
import Toast from "../component/Toast"
import Swal from "sweetalert2"

const Product = () => {
    const navigate = useNavigate();
    const [datas, setDatas] = useState([])
    const [showAlert, setShowAlert] = useState(false)
    const [loading, setLoading] = useState(true);
    const [checkedMap, setCheckedMap] = useState({});
    const [checkedMapClearance, setCheckedMapClearance] = useState({});
    const [disabledBtn, setDisabledBtn] = useState({})
    const [excludeBtn, setExcludedBtn] = useState({})
    const [excludeBtnLoading, setExcludedBtnLoading] = useState({})
    const [loadXml, setLoadXml] = useState(false);
    const [loadGenerateXML, setLoadGenerateXml] = useState(false);
    const [exportLoader, setExportLoader] = useState(false);


    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })
    

    const getData = async () => {
        await axios.get(`https://hoopsdevteam.com/api_web/controler/cmsNew_rr.php/?index=2`)
            .then(res => { 
                const initialCheckedMap = {};
                const initialCheckedMapClearance = {};
                const initialButtonMap = {}
                const initialExcludedMap = {}
                if (res.data.state === 200) {
                    setDatas(res.data.data)
                    res.data.data.forEach((row) => {
                        initialCheckedMap[row.id_product] = row.is_active === '1';
                    });
                    res.data.data.forEach((row) => {
                        initialButtonMap[row.id_product] = row.is_new === 'Y';
                    });
                    res.data.data.forEach((row) => {
                        initialExcludedMap[row.id_product] = row.isExcludeStore === '1';
                    });
                    res.data.data.forEach((row) => {
                        initialCheckedMapClearance[row.id_product] = row.is_clearance === 'Y';
                    });
                    setCheckedMap(initialCheckedMap);
                    setCheckedMapClearance(initialCheckedMapClearance);
                    setDisabledBtn(initialButtonMap);
                    setExcludedBtn(initialExcludedMap);
                    setLoading(false)
                }
            })
    }
    const [selectedRow, setSelectedRow] = useState(null);
   
    const data = useMemo(() => datas, [datas])
    const columns = useMemo(() => [
        {
            Header: "Image",
            accessor: "image",
            Cell: ({ cell }) => (
                (cell.value) ? <Image src={cell.value} width={50} fluid rounded /> : <Image src="https://via.placeholder.com/500x400.png" width={50} fluid rounded />
            )
        },
        {
            Header: "ID",
            accessor: "id_product",
            filter: "text"
        },
        {
            Header: "Name",
            accessor: "product_name",
            filter: 'text',
        },
        {
            Header: "Active",
            accessor: "is_active",
            filter: true,
            Cell: ({ cell }) => (
                <Checkbox
                    toggle
                    checked={cell.value == '1' ? true : false}
                    style={{ transform: 'scale(.7)' }}
                    onChange={(e) => handleChangeDisplayOne(e, cell.row.values)}
                />
            )
        },
        {
            Header: "Date Add",
            accessor: "date_add"
        },
        {
            Header: "Qty",
            accessor: "current_qty",
            filter: "text"
        },
        {
            Header: "Action",
            accessor: "act",
            filter: false,
            Cell: ({ cell }) => {
                return (
                    <Fragment>
                        <Dropdown
                            floating
                            labeled
                            className='icon'
                            icon="ellipsis vertical"
                        >
                            <Dropdown.Menu className="left">
                                <Dropdown.Item icon="images outline" text="Image" onClick={() => handleClickActionImage(cell.row.original)} />
                                <Dropdown.Item icon="tasks" text="Attribute" onClick={() => handleClickActionAttribute(cell.row.original)} />
                                <Dropdown.Item icon="edit" text="Edit" onClick={() => handleClickActionEdit(cell.row.original)} />
                            </Dropdown.Menu>
                        </Dropdown>
                    </Fragment>
                )
            }
        }
    ], [])

    const handleChangeDisplay = (idProduct) => {
        updateState(idProduct)
    }
    
    const handleChangeDisplayClearance = (idProduct) => {
        updateStateClearance(idProduct)
    }

    const handleChangeDisplayOne = (e, data) => {
        updateState(data.id_product)
    }

    const updateState = (id) => {
        let data = {
            id_product: id
        }
        axios.post("https://hoopsdevteam.com/api_web/controler/cms_rr.php/?index=16", data)
            .then(res => {
                if (res.data.state === 200) {
                    // getData()
                    Toast.fire({
                        icon:"success",
                        text : "Product status changed",
                        position: "top-end",
                    })
                } else {
                    Toast.fire({
                        icon:"error",
                        text : res.data.error,
                        position: "top-end",
                    })
                }
            })
    }

    const updateStateClearance = (id) => {
        // 🔥 optimistic update (langsung ubah UI)
        setCheckedMapClearance((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));

        let data = {
            id_product: id
        };

        axios.post("https://hoopsdevteam.com/api_web/controler/cmsNew_rr.php/?index=39", data)
            .then(res => {
                if (res.data.state === 200) {
                    Toast.fire({
                        icon: "success",
                        text: "Product status clearance changed",
                        position: "top-end",
                    });
                } else {
                    // ❗ rollback kalau gagal
                    setCheckedMapClearance((prev) => ({
                        ...prev,
                        [id]: !prev[id],
                    }));

                    Toast.fire({
                        icon: "error",
                        text: res.data.error,
                        position: "top-end",
                    });
                }
            })
            .catch(() => {
                // ❗ rollback kalau error
                setCheckedMapClearance((prev) => ({
                    ...prev,
                    [id]: !prev[id],
                }));
            });
    };


    const updateExclude = (param) => {
        console.log(param)
        setExcludedBtnLoading((prevButtonMap) => ({
            ...prevButtonMap,
            [param.id_product]: true,
        }));
        let data = {
            id_product: param.id_product,
            exclude_store: param.isExcludeStore == '1' ? false : true
        }
        axios.post("https://hoopsdevteam.com/api_web/controler/cmsNew_rr.php/?index=38", data)
        .then(res => {
            console.log(res)
            if (res.data.state === 200) {
                // getData()
                setExcludedBtnLoading((prevButtonMap) => ({
                    ...prevButtonMap,
                    [param.id_product]: false,
                }));
                setExcludedBtn((prevButtonMap) => ({
                    ...prevButtonMap,
                    [param.id_product]: !prevButtonMap[param.id_product],
                }));
                Toast.fire({
                    icon: "success",
                    text: res.data.message,
                    position: "top-end",
                })
            } else {
                setExcludedBtnLoading((prevButtonMap) => ({
                    ...prevButtonMap,
                    [param.id_product]: false,
                }));
                Toast.fire({
                    icon: "error",
                    text: res.data.message,
                    position: "top-end",
                })
            }
        }).catch(error => {
            setExcludedBtnLoading((prevButtonMap) => ({
                ...prevButtonMap,
                [param.id_product]: false,
            }));
            Toast.fire({
                icon: "error",
                text: error,
                position: "top-end",
            })
        })
    }

    const handleClickProductAdd = () => (navigate('/product_add'))

    const handleClickActionImage = (row) => {
        setSelectedRow(row)
        navigate('/product_image', { state: { selected: row } })
    }

    const handleClickActionAttribute = (row) => {
        axios.post("https://hoopsdevteam.com/api_web/controler/cms_rr.php/?index=19", { id_product: row.id_product })
            .then(res => {
                setSelectedRow(row)
                if (res.data.state === 200) {
                    navigate('/product_attribute', { state: { selected: row } })
                }

                if (res.data.state === 300) {
                    navigate('/product_attribute_edit', { state: { selected: row } })
                }
            })
    }

    const handleClickActionEdit = (row) => {
        setSelectedRow(row)
        navigate('/product_edit', { state: { selected: row } })
    }

    const handleClickActionRemNew = (row) => {
        const data = new URLSearchParams()
        const productId = row.id_product;
        data.append('id_product', row.id_product)
        data.append('status', 'N')
        axios.post("https://hoopsdevteam.com/api_web/controler/product_rr.php/?index=20", data)
        .then(res => {
            if ( res.data.state === 200){
                Toast.fire({
                    icon:'success',
                    text : "The product has been released from the new product group",
                    position: "top-end",
                })
            } else {
                Toast.fire({
                    icon:'error',
                    text : "Failed to change product",
                    position: "top-end",
                })
            }
        })
        setDisabledBtn((prevButtonMap) => ({
            ...prevButtonMap,
            [productId]: !prevButtonMap[productId],
        }));
    }

    const handleClickActionRemNewBack = (row) => {
        const data = new URLSearchParams()
        const productId = row.id_product;
        data.append('id_product', row.id_product)
        data.append('status', 'Y')
        axios.post("https://hoopsdevteam.com/api_web/controler/product_rr.php/?index=20", data)
        .then(res => {
            if ( res.data.state === 200){
                Toast.fire({
                    icon:'success',
                    text : "The product has been added to a new product group",
                    position: "top-end",
                })
            } else {
                Toast.fire({
                    icon:'error',
                    text : "Failed to change product",
                    position: "top-end",
                })
            }
        })
        setDisabledBtn((prevButtonMap) => ({
            ...prevButtonMap,
            [productId]: !prevButtonMap[productId],
        }));
    }
    
    const rederedButton = (params) => {
        const productId = params.data.id_product
        return (
            <Fragment>
                <Button.Group basic size="mini">
                    <Popup content="Add Image" size="small" trigger={
                        <Button icon="image" onClick={() => handleClickActionImage(params.data)} />
                    }/>
                    <Popup content="Add Attribute" size="small" trigger={
                        <Button icon="tasks" onClick={() => handleClickActionAttribute(params.data)} />
                    }/>
                    <Popup content="Edit product" size="small" trigger={
                        <Button icon="edit" onClick={() => handleClickActionEdit(params.data)} />
                    }/>
                    { 
                        (disabledBtn[productId]) ?
                            <Popup content="Remove product from New" size="small" trigger={
                                <Button icon="eraser" onClick={() => handleClickActionRemNew(params.data)} />
                            }/>
                        : 
                            <Popup content="Set back to New if stay in period" size="small" trigger={
                                <Button icon="undo" onClick={() => handleClickActionRemNewBack(params.data)} />
                            }/>
                    }
                    {
                        excludeBtnLoading[productId] ? (
                            <Button icon="loading" loading={true} />
                        ) :
                        !excludeBtn[productId] ? (
                            <Popup content="Exclude Store Stock" size="small" trigger={
                                <Button
                                    icon
                                    style={{ backgroundColor: '#db2828', color: 'white' }} // red
                                    onClick={() => updateExclude(params.data)}
                                >
                                    <i className="ban icon" />
                                </Button>
                            } />
                        ) : (
                            <Popup content="Include Store Stock" size="small" trigger={
                            <Button
                                icon
                                style={{ backgroundColor: '#21ba45', color: 'white' }} // green
                                onClick={() => updateExclude(params.data)}
                            >
                                <i className="check circle icon" />
                            </Button>
                            } />
                        )
                    }
                </Button.Group>
            </Fragment>
        )
    }


    // Fungsi yang akan dipanggil ketika terjadi perubahan pada Checkbox
    const handleCheckboxChange = (params) => {
        const productId = params.data.id_product;
        handleChangeDisplay(productId)
        // Mengupdate status checked untuk baris yang sesuai
        setCheckedMap((prevCheckedMap) => ({
            ...prevCheckedMap,
            [productId]: !prevCheckedMap[productId],
        }));
    };
    
    const handleCheckboxChangeClearance = (params) => {
        const productId = params.data.id_product;
        handleChangeDisplayClearance(productId)
        // Mengupdate status checked untuk baris yang sesuai
        setCheckedMapClearance((prevCheckedMapClearance) => ({
            ...prevCheckedMapClearance,
            [productId]: !prevCheckedMapClearance[productId],
        }));
    };

    const renderedCheck = (params) => {
        const productId = params.data.id_product;
        
        return (
            <Checkbox
                checked={checkedMap[productId] || false}
                id={productId}
                onChange={() => handleCheckboxChange(params)}
            />
        );
    };
    
    const renderedCheckClearance = (params) => {
        const productId = params.data.id_product;

           console.log("CLEARANCE RENDER");
        return (
            <Checkbox
                checked={checkedMapClearance[productId] || false}
                id={productId}
                onChange={() => handleCheckboxChangeClearance(params)}
            />
        );
    };

    const rendererImage = (params) => {
        const image = params.data.image
        return (
            <div style={{width: 45, height:40}}>
            <Image src={image ? image : 'https://via.placeholder.com/500x400.png'} alt={params.data.id_product} rounded fluid/>
            </div>
        )
    }

    const columnDefs = [
        {   
            headerName: 'Image',
            field: 'image',
            cellRenderer:rendererImage, 
            suppressMenu:true,
            cellStyle: { display: 'flex', alignItems: 'center' }, width: 100 
        },
        { headerName: 'Product ID', field: 'id_product', width: 140 },
        { headerName: 'Product Name', field: 'product_name', width: 200  },
        { headerName: 'Meta Title', field: 'meta_title', width: 200  },
        { headerName: 'Qty', field: 'current_qty', width: 80  },
        { headerName: 'Size Group', field: 'size_group', width: 120 },
        {
            headerName: 'Active',
            field: 'is_active',
            cellRenderer: renderedCheck,
            cellStyle: { display: 'flex', alignItems: 'center' }, width: 100 
        },
        {
            headerName: 'Clearance',
            field: 'is_clearance',
            cellRenderer: (params) => {
                const id = params.data.id_product
                return (
                    <Checkbox
                        toggle
                        style={{verticalAlign: 'middle' }}
                        checked={checkedMapClearance[id] || false}
                        onChange={() => updateStateClearance(id)}
                    />
                )
            }, width: 120 
        },
        { headerName : 'Date Add', field: 'date_add', width: 140 },
        {
            headerName: 'Action',
            field : 'action',
            cellRenderer: rederedButton,    
            suppressMenu: true,
            cellStyle: { display: 'flex', alignItems: 'center' }, width: 220 

        }
    ];

    const handleCreatePixel = () => {
        setLoadXml(true)
        axios({
            method: "POST",
            url: `${global.SRV}api_rudrunner_cms/controler/product.php/?index=2`,
            headers: {
                'Content-Type': 'application/json',
            },
        })
        .then(res => { 
            if (res.data.state === 200){
                setLoadXml(false)
                window.location.href = res.data.url
            }
        })
    }

    useEffect(() => {
        getData()
    }, [])
    
    const exportOrder = async () => {
        setExportLoader(true)
        await axios({
            method: "GET",
            url: `${global.SRV}api_rudrunner_cms/controler/export.php/?index=2`,
            headers: { 'Content-Type': 'application/json' },
        })
            .then(res => {
                if (res.data.state === 200) {
                    downloadFile()
                }
                setExportLoader(false)
            })
    }
    
    const downloadFile = () => {
        const timestamp = new Date().getTime(); // Mendapatkan timestamp saat ini
        const fileUrl = `${global.SRV}download/rudrunner_product.xlsx?timestamp=${timestamp}`;
    
        const link = document.createElement('a');
        link.href = fileUrl;
        link.setAttribute('download', 'rudrunner_product.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
    
    const generateXML = () => {
        setLoadGenerateXml(true)
        axios({
            method: "GET",
            url: `https://rudrunner.co.id/api_rudrunner/controler/generateXML.php`,
            headers: {
                'Content-Type': 'application/json',
            },
        })
        .then(res => {
            successAlert(res.data?.message);
        })
        .catch((err) => {
            console.log(err) 
            errorAlert(`Error ${err.response?.status}: ${err.response?.data.message}`);
        }).finally(() => {
            setLoadGenerateXml(false) 
        });
    }
    
    const successAlert = (title) => {
        Toast.fire({
            icon: 'success',
            title: `${title}` || 'Request running successfully',
            timer: 5000,
            timerProgressBar: true,
            showConfirmButton: false,
            showCloseButton: false
        });
    }

    const errorAlert = (title, text = null) => {
    
        Toast.fire({
            icon: 'error',
            title: title || 'Unknown error occurred',
            text: text || "",
            timer: null,
            timerProgressBar: false,
            showConfirmButton: false,
            showCloseButton: true
        });
      };

    return (
        <Container fluid>
            <Row>
                <div className="text-facebook h3 mb-0">Product list</div>
                <span className="text-muted">list of products that have been added to the website</span>
            </Row>
            <Divider />
            <Row>
                <Col lg={12}>
                    <Pesan variant="success" show={showAlert} setShowAlert={setShowAlert} content="update product state success" header="Success" />
                </Col>
            </Row>
            <Row className="mb-3 pt-3">
                <Col md={12} className="d-flex justify-content-start">
                    <Button content="Add Product" icon="plus" color="facebook" onClick={handleClickProductAdd} />
                    <Button content="Update Product xml for Pixel" onClick={() => handleCreatePixel()} color="blue" loading={loadXml}/>
                    <Button content="Generate Sitemap" onClick={() => generateXML()} color="green" loading={loadGenerateXML} />
                </Col>
            </Row>
            <Row>
                <Col md={12} xl={12} sm={12}>
                    {/* <Table columns={columns} data={data} /> */}
                    <div className="me-2 text-end">
                        <Button content="Export Product Data" onClick={() => exportOrder()} loading={exportLoader} size="mini" color="facebook" icon="share square"/>
                    </div>
                    <AGtable 
                    rowData={data ? data : null} 
                    columnDefs={columnDefs} 
                    loading={loading}
                    exportFileName="data_product"
                    />
                </Col>
            </Row>
        </Container>
    )
}

export default Product;